import { Fragment, useEffect, useState } from 'react'
import { MainMenu, MenuDrawerContent, MenuItems, Resizable, ToggleMenuButton } from './styles'
import ResponsesTab from './responses/ResponsesTab'
import PagesTab from './pages/PagesTab'
import { setActiveTab_action, toggleMainMenu_action } from 'store/actions'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { ReactComponent as BackIcon } from 'assets/images/icons/back.svg'
import { ReactComponent as MenuIcon } from 'assets/images/icons/menu.svg'
import { CONSTANTS, sliceText } from 'utils/helpers'
import { getMenuWidth, setMenuWidth } from 'utils/storageUtils'

var resizer

export function MainmenuComponent(props) {

  const [isResizing, setIsResizing] = useState(false);

  const {
    company,
    app: { isMainMenuOpen },
    fullScreenStatus
  } = props
  const activeTab = props.app.mainmenuTabs.filter((t) => t.isActive)[0]
  const switchTab = (tab) => {
    props.setActiveTab(tab.key)
  }

  useEffect(() => {
    document.body.style.removeProperty('overflow-y')
    if (isMainMenuOpen && window.innerWidth < 576) {
      document.body.style.overflowY = 'hidden'
    }
  }, [isMainMenuOpen])

  useEffect(() => {
    const getResizer = () => {
      resizer = document.getElementById('resizer')
      if (!resizer) {
        getResizer()
      } else if (window.innerWidth > 992) {
        resizer.addEventListener('mousedown', initResize, false)
      }
    }
    const initResize = () => {
      window.addEventListener('mousemove', Resize, false)
      window.addEventListener('mouseup', stopResize, false)
    }
    const Resize = (e) => {
      if (e.clientX >= CONSTANTS.mainMenuMinWidth) {
        const mainmenu = document.getElementById('mainmenu');
        setIsResizing(true)
        const width = e.clientX - mainmenu.offsetLeft + 'px'
        mainmenu.style.width = width
      }
    }

    const stopResize = (e) => {
      const mainmenu = document.getElementById('mainmenu')
      setMenuWidth(mainmenu.style.width)
      setIsResizing(false)
      window.removeEventListener('mousemove', Resize, false)
      window.removeEventListener('mouseup', stopResize, false)
    }
    getResizer()

    if (getMenuWidth()) {
      const mainmenu = document.getElementById('mainmenu')
      if (window.innerWidth > 992) {
        mainmenu.style.width = getMenuWidth()
      } else if (window.innerWidth > 576) {
        mainmenu.style.width = CONSTANTS.mainMenuMinWidth
      } else {
        mainmenu.style.width = '100%'
      }
    }
  }, [])

  return (
    <Fragment>
      <MainMenu isFullScreen={fullScreenStatus} id='mainmenu' className={isMainMenuOpen ? 'open' : ''}>
        <div className='logo'>
          <Link to='/'>
            {company.company.logo && (
              <div className={`${company.company.logo ? 'has-company-logo' : ''}`}>
                <img src={company.company.logo} alt='logo' />
              </div>
            )}
            {/* <div className='company-name'> {sliceText(company.company.name, 17)} </div> */}
            <div className='company-name'> {company.company.name ? (isResizing ? company.company.name : sliceText(company.company.name, (parseInt((getMenuWidth() ?? '250px')?.slice(0, -2))) / 16)) : ''} </div>
          </Link>
        </div>
        <MenuItems>
          {props.app.mainmenuTabs.map((tab) => (
            <li key={tab.key} onClick={() => switchTab(tab)} className={`${activeTab.key === tab.key ? 'active' : ''}`}>
              <div className='icon'>{tab.icon}</div>
              <div className='title'> {tab.title} </div>
            </li>
          ))}
        </MenuItems>
        <MenuDrawerContent>
          {activeTab.key === 'responses' && <ResponsesTab />}
          {activeTab.key === 'pages' && <PagesTab />}
        </MenuDrawerContent>
        <Resizable id='resizer'>
          <MenuIcon />
        </Resizable>
        <ToggleMenuButton id='toggleMenuButton' open={isMainMenuOpen} onClick={() => props.toggleMainMenu(!isMainMenuOpen)}>
          <BackIcon />
        </ToggleMenuButton>
      </MainMenu>
    </Fragment>
  )
}

const mapStateToProps = (state) => ({
  app: state.app,
  company: state.company,
  fullScreenStatus: state.contents.isFullScreen
})

const mapDispatchToProps = (dispatch) => ({
  setActiveTab: (key) => dispatch(setActiveTab_action(key)),
  toggleMainMenu: (status) => dispatch(toggleMainMenu_action(status))
})
export default connect(mapStateToProps, mapDispatchToProps)(MainmenuComponent)
